import { utils } from '@frontend/partviewer';

import {
  DisplayWrapper,
  DisplayTitle,
  DisplayEntry,
  DisplayEntryWrapper,
} from 'modules/common/viewer/components/ViewerDisplayElements';

const { formatLengthProp } = utils;

const SelectorCumulativeInfoComponent = ({
  cumulativeInfo,
  displayScale,
  displayUnits,
  nativeUnits,
  dimensionalPrecision,
}) => {
  return cumulativeInfo && (cumulativeInfo.area || cumulativeInfo.length) ? (
    <DisplayWrapper>
      <DisplayTitle>Cumulative Selection</DisplayTitle>
      {cumulativeInfo.area > 0 && (
        <DisplayEntryWrapper>
          <DisplayEntry>Face Area:</DisplayEntry>
          <DisplayEntry>
            {formatLengthProp({
              value: cumulativeInfo.area,
              order: 2,
              displayUnits,
              nativeUnits,
              dimensionalPrecision,
              displayScale,
            })}
          </DisplayEntry>
        </DisplayEntryWrapper>
      )}
      {cumulativeInfo.length > 0 && (
        <DisplayEntryWrapper>
          <DisplayEntry>Edge Length:</DisplayEntry>
          <DisplayEntry>
            {formatLengthProp({
              value: cumulativeInfo.length,
              order: 1,
              displayUnits,
              nativeUnits,
              dimensionalPrecision,
              displayScale,
            })}
          </DisplayEntry>
        </DisplayEntryWrapper>
      )}{' '}
    </DisplayWrapper>
  ) : null;
};

export default SelectorCumulativeInfoComponent;
